export const PRODUCT_DETAILS_REQUEST='PRODUCT_DETAILS_REQUEST';
export const PRODUCT_DETAILS_SUCCESS='PRODUCT_DETAILS_SUCCESS';
export const PRODUCT_DETAILS_FAIL='PRODUCT_DETAILS_FAIL';
export const RESET_PRODUCT_DETAILS='RESET_PRODUCT_DETAILS';


export const DASHBOARD_DETAILS_REQUEST='DASHBOARD_DETAILS_REQUEST';
export const DASHBOARD_DETAILS_SUCCESS='DASHBOARD_DETAILS_SUCCESS';
export const DASHBOARD_DETAILS_FAIL='DASHBOARD_DETAILS_FAIL';



export const ADD_REVIEW='ADD_REVIEW';
export const CLEAR_ERRORS='CLEAR_ERRORS'
